import { useRef, useState } from "react";
import { StreamChat } from "stream-chat";

const chatClient = StreamChat.getInstance(
  process.env.REACT_APP_STREAM_API_KEY ?? ""
);

export const useChatClient = () => {
  const [clientIsReady, setClientIsReady] = useState(false);
  const unsubscribePushListenersRef = useRef<() => void>();

  const setupClient = async (
    chatUserId: string,
    chatUserName: string,
    chatUserToken?: string
  ) => {
    if (!chatClient.userID) {
      unsubscribePushListenersRef.current?.();
      try {
        const user = {
          id: chatUserId,
          name: chatUserName,
        };
        const connectedUser = await chatClient.connectUser(user, chatUserToken);
        const initialUnreadCount = connectedUser?.me?.total_unread_count;
        console.log("initialUnreadCount", initialUnreadCount);
        console.log("Connected");
        setClientIsReady(true);
      } catch (error) {
        if (error instanceof Error) {
          console.error(
            `An error occurred while connecting the user: ${error.message}`
          );
        }
      }
    } else {
      console.log("already set");
    }
  };
  // useEffect(() => {

  //   };

  //   // If the chat client has a value in the field `userID`, a user is already connected
  //   // and we can skip trying to connect the user again.
  //   if (!chatClient.userID) {
  //     setupClient();
  //   }
  // }, []);

  return {
    clientIsReady,
    chatClient,
    setupClient,
  };
};
